export interface CmsApplianceCareCancellations {
  applianceCareCancellations: string;
}
